import { FC } from "react";
import api from "./api";
import ApiContext from "./api.context";

const ApiProvider: FC = ({ children }) => {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
};

export default ApiProvider;
